import { type ReactElement } from 'react';
import PageShell, { PageSection } from '../components/PageShell';

export default function Dokumentation(): ReactElement {
  return (
    <PageShell
      title="Dokumentation"
      intro="Anleitungen und Hintergründe zu den Funktionen von Saldify."
    >
      <PageSection title="Funktionen im Überblick">
        <p>
          Eine ausführliche Übersicht aller Funktionen – von Rechnungen über
          Belegerfassung bis zu Auswertungen – finden Sie unter{' '}
          <a href="/funktionen" className="text-primary-600 hover:underline">
            Funktionen
          </a>
          .
        </p>
      </PageSection>

      <PageSection title="Detaillierte Anleitungen">
        <p>
          Wir bauen unsere Dokumentation kontinuierlich aus. Konkrete Fragen zur
          Bedienung beantwortet derzeit am schnellsten unser{' '}
          <a href="/hilfe" className="text-primary-600 hover:underline">
            Hilfe-Center
          </a>{' '}
          oder unser Team über die{' '}
          <a href="/kontakt" className="text-primary-600 hover:underline">
            Kontaktseite
          </a>
          .
        </p>
      </PageSection>
    </PageShell>
  );
}
